import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, useApi } from "../../lib/api";
import { Input, Field, Btn, Select } from "../kit";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { EXPENSE_CATEGORIES, PAYMENT_METHODS } from "../../lib/constants";

export function ExpenseDialog({ e, onClose, onSaved }) {
  const [f, setF] = useState({ method: "Tunai", ...e });
  const [busy, setBusy] = useState(false);
  const { data: opt } = useApi("/settings/options", 0);
  const set = (k) => (ev) => setF({ ...f, [k]: ev.target.value });
  const submit = async (ev) => {
    ev.preventDefault();
    setBusy(true);
    const body = { ...f, amount: Number(f.amount) };
    try {
      f.id ? await api.put(`/finance/expenses/${f.id}`, body) : await api.post("/finance/expenses", body);
      toast.success("Pengeluaran disimpan");
      onSaved();
    } catch (x) { toast.error(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-2xl" data-testid="expense-dialog">
        <DialogHeader><DialogTitle>{f.id ? "Edit Pengeluaran" : "Pengeluaran Baru"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Tanggal"><Input type="date" required value={f.date} onChange={set("date")} data-testid="exp-date-input" /></Field>
            <Field label="Kategori"><Select options={EXPENSE_CATEGORIES} value={f.category} onChange={set("category")} data-testid="exp-category-select" /></Field>
          </div>
          <Field label="Supplier / Penerima"><Input value={f.supplier} onChange={set("supplier")} placeholder="Opsional" data-testid="exp-supplier-input" /></Field>
          <Field label="Keterangan"><Input required value={f.description} onChange={set("description")} placeholder="Contoh: Beli cup PP 16oz 10 dus" data-testid="exp-description-input" /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Nominal (Rp)"><Input type="number" inputMode="decimal" min="1" required value={f.amount} onChange={set("amount")} className="text-xl font-mono" data-testid="exp-amount-input" /></Field>
            <Field label="Metode"><Select options={opt?.payment_methods || PAYMENT_METHODS} value={f.method} onChange={set("method")} data-testid="exp-method-select" /></Field>
          </div>
          <Field label="Catatan"><Input value={f.note} onChange={set("note")} placeholder="Opsional" data-testid="exp-note-input" /></Field>
          <Btn type="submit" loading={busy} className="w-full" data-testid="exp-save-btn">Simpan</Btn>
        </form>
      </DialogContent>
    </Dialog>
  );
}
